// extracted by mini-css-extract-plugin
module.exports = {"shadow":"Summary_shadow__N0Lp3","summary":"Summary_summary__uX_-n","header":"Summary_header__nzEGa","tabContainer":"Summary_tabContainer__N-BA2"};